import type { CSSProperties } from 'react';
import { useId } from 'react';

import { unitMapping } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = {
  color?: Color;
  size?: keyof typeof unitMapping;
};

export const AllSeasons2025 = ({
  size = 2,
  color = 'var(--c-nd-600)',
}: Props) => {
  return (
    <svg viewBox="0 0 24 17" fill="none" style={{ height: unitMapping[size] }}>
      <path
        d="M2.92174 8.98932V1.26758H0V7.9394L2.92174 8.98932Z"
        fill={color}
      />
      <path
        d="M21.0783 8.98932V1.26758H24V7.9394L21.0783 8.98932Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0347 1.26758V15.3246L14.2158 16.5024H9.78418L3.96518 15.3246L3.96518 1.26758L20.0347 1.26758ZM16.0062 11.6195L14.6556 10.2689L13.5699 11.3546H11.1601L10.4319 10.6264V6.62772L11.1601 5.89948H13.4772L14.563 6.98522L15.9135 5.63467L14.4041 4.12523H10.22L8.44575 5.89948V11.3546L10.22 13.1289H14.4967L16.0062 11.6195Z"
        fill={color}
        shapeRendering="crispEdges"
      />
    </svg>
  );
};

export const AllSeasons2026 = ({
  size = 2,
  color = 'var(--c-nd-900)',
}: Props) => {
  const id = useId();
  return (
    <svg
      style={{ height: unitMapping[size] }}
      viewBox="0 0 330 232"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id={id}
        style={{ maskType: 'luminance' } as CSSProperties}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="330"
        height="232"
      >
        <path d="M330 0H0V232H330V0Z" fill={color} />
      </mask>
      <g mask={`url(#${id})`}>
        <path
          d="M347.358 177.689L280.323 232.448H-18V54.904L39.8281 0H347.358V177.689ZM164.903 29C132.722 29 120.154 39.1008 120.154 60.829V171.469C120.154 193.197 132.722 203.299 164.903 203.299C197.085 203.299 209.535 193.197 209.535 171.469V136.703H185.223V183.684H144.467V48.4971H185.223V95.243H209.535V60.829C209.535 39.1008 197.085 29 164.903 29Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
